import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { FormControl, FormLabel, Select as ChakraSelect } from "@chakra-ui/react";
import Select from "~components/Form/components/Select";
import ReactSelect from "react-select";
import { Lupa, CleanFiltersIcon, ChevronDownButton } from "~misc/icons";
import useSelect from "~components/Form/hooks/useSelect";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import { Link, useParams, useNavigate } from "react-router-dom";
import useModalSimulators from "~components/Modal/hooks/useModalSimulators";
import ModalSimulators from "~components/Modal/ModalSimulators";
import useUsuario from "~fetchs/useUsuario";

const Filtro = ({ setFilters, clientes, cliente, simulacoesFiltro }) => {
  const { parameter: idCliente } = useParams();
  const navigate = useNavigate();
  const { usuario } = useUsuario();
  const acessoSimuladorConcreto = usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const viteMode = import.meta.env.VITE_MODE;
  const simuladoresLink = viteMode === "dev" ? "qa" : viteMode === "prod" ? "" : viteMode;
  const verPropostasLink = `https://comercial${simuladoresLink ? `-${simuladoresLink}` : ""}.vcimentos.com/#/imo/clientes`;



  const gruposDisponiveis = useMemo(() => {
    return simulacoesFiltro?.gruposMateriais ?? [];
  }, [simulacoesFiltro]);

  const produtosDisponiveis = useMemo(() => {
    return simulacoesFiltro?.produtos ?? [];
  }, [simulacoesFiltro]);

  const {
    grupoProduto,
    grupoProdutoSelect,
    optionGruposProduto: optGrupos,
    onChangeGrupoProduto,
    CleanForFilter: CleanGrupoProduto,
  } = useGrupoProduto({ formikRef: null, name: "grupoProdutoId", camposOpt: ['nome'], gruposPorFamilia: gruposDisponiveis } );

  const {
    produto,
    produtosSelect,
    optionProdutos: optProdutos,
    onChangeProduto,
    CleanForFilter: CleanProduto,
  } = useProduto({ grupoProduto, produtosDisponiveis });

  const clienteSelecionado = useMemo(() => {
    if (!idCliente) return null;

    const option = clientes?.find((item) => item.value == parseInt(idCliente));
    if (option) return option;

    if (Number(cliente?.id) !== Number(idCliente)) return null;

    const codigo = cliente.codigo != "" && cliente.codigo != null
      ? cliente.codigo
      : cliente.codigoProspect;

    return {
      value: cliente.id,
      label: [codigo, cliente.razaoSocial, cliente.documento].join(" - "),
      escritorioVendaId: cliente.escritorioVendaId || null,
    };
  }, [idCliente, clientes, cliente]);
  
  const optionGruposProduto = useMemo(() => {
    optGrupos.unshift({
      value: "",
      label: "Todos",
    });
    return optGrupos;
  }, [optGrupos]);

  const optionProdutos = useMemo(() => {
    optProdutos.unshift({
      value: "",
      label: "Todos",
    });
    return optProdutos;
  }, [optProdutos]);

  const onChangeCliente = (e) => {
    navigate(`/simuladores/simulacoes/${e.value}`);
  };

  useLayoutEffect(() => {
    onChangeProduto({ value: "", label: "Todos" });
    onChangeGrupoProduto({ value: "", label: "Todos" });
  }, []);

  const [simulacaoTipo, setSimulacaoTipo] = useState({ value: "", label: "Todos" });
  const [periodo, setPeriodo] = useState({ value: "", label: "Todos" });
  const [orderBy, setOrderBy] = useState({ value: "recente", label: "Mais Recentes" });

  const clearFilters = () => {
    /**
     * Volta pro default
     */
    setSimulacaoTipo({ value: "", label: "Todos" });
    setPeriodo({ value: "", label: "Todos" });
    setOrderBy({ value: "recente", label: "Mais Recentes" });
    CleanGrupoProduto({ value: "", label: "Todos" });
    CleanProduto({ value: "", label: "Todos" });
  };

  useEffect(() => {
    setFilters({
      grupoProduto: grupoProduto,
      produto: produto,
      simulacaoTipo: simulacaoTipo?.value,
      periodo: periodo?.value,
      orderBy: orderBy?.value,
    });
  }, [grupoProduto, produto, simulacaoTipo, periodo, orderBy]);

  const { isModalOpenSimulators, setModalOpenSimulators, closeModalSimulators, openModalSimulators } =
    useModalSimulators();

  const handleSimulators = () => {
    openModalSimulators();
  };

  return (
    <div className="pt-5 container gap-x-2">
      <FormControl>
        <div className={`md:col-span-3 grid ${acessoSimuladorConcreto ? 'md:grid-cols-[49.5%_24%_24%]' : 'md:grid-cols-[70%_30%]'} gap-4`}>
          <Select
            options={clientes}
            className="h-full relative z-50 font-bold text-primaria"
            onChange={(e) => onChangeCliente(e)}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                height: "100%",
                color: "#01054C",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                color: "#01054C",
              }),
            }}
            value={clienteSelecionado}
          />
          {acessoSimuladorConcreto && (
            <Link to={verPropostasLink} target="_blank" className="button-search flex justify-center items-center h-[50px] py-2 px-8 whitespace-nowrap bg-pendente text-white rounded-md font-bold">
              Simulador de Concreto
            </Link>
          )}
          <button
            className="bg-primaria hover:bg-white hover:drop-shadow-sm text-white hover:text-primaria transition-all p-1 rounded-md font-bold h-[50px]"
            onClick={handleSimulators}
          >
            Nova Simulação
          </button>
        </div>
      </FormControl>
      
      <div className="grid md:grid-cols-2 gap-x-4">
        <FormControl>
          <FormLabel className="mt-4 pl-1">Grupo de Produto:</FormLabel>
            <Select
              options={optionGruposProduto}
              placeholder="Grupos de Produto:"
              size="lg"
              name="grupoProdutos"
              onChange={(e) => onChangeGrupoProduto(e)}
              className="!bg-[transparent] select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
              {...grupoProdutoSelect}
            />
        </FormControl>
        <FormControl>
          <FormLabel className="mt-4 pl-1">Produto:</FormLabel>
          <Select
            options={optionProdutos}
            defaultValue={{ value: "", label: "Todos" }}
            placeholder="Produtos:"
            size="lg"
            name="produto"
            onChange={(e) => onChangeProduto(e)}
            className="!bg-[transparent] select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
            {...produtosSelect}
          />
        </FormControl>
        <FormControl>
          <FormLabel className="mt-4 pl-1">Tipo de simulação:</FormLabel>
          <Select
            size="lg"
            name="simulacaoTipo"
            options={[
              { value: "", label: "Todos" },
              { value: "ensacados", label: "Ensacados" },
            ]}
            value={simulacaoTipo}
            onChange={(target) => setSimulacaoTipo(target)}
            className="!bg-[transparent] select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
          />
        </FormControl>
        <FormControl>
          <FormLabel className="mt-4 pl-1">Período:</FormLabel>
          <Select
            size="lg"
            name="periodo"
            value={periodo}
            options={[
              { value: "", label: "Todos" },
              { value: "last3", label: "Últimos 3 dias" },
              { value: "last7", label: "Últimos 7 dias" },
              { value: "last15", label: "Últimos 15 dias" },
              { value: "last30", label: "Últimos 30 dias" },
            ]}
            onChange={(target) => setPeriodo(target)}
            className="!bg-[transparent] select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
          />
        </FormControl>
      </div>

      <div className="flex justify-between md:col-span-2">
        <div>
          <button
            className="flex items-center gap-4 ml-auto
            mt-4 hover:scale-105 transition-transform duration-300 cursor-pointer"
            onClick={() => clearFilters()}
          >
            <span className="font-semibold text-lg cursor-pointer">Limpar Filtros</span>
            <CleanFiltersIcon />
          </button>
        </div>

        <div className="relative flex items-center gap-2">
          <label className="text-sm font-bold" htmlFor="orderBy">
            Ordenar por:{" "}
          </label>
          <Select
            name="orderBy"
            id="orderBy"
            value={orderBy}
            variation="compact-inline"
            options={[
              { value: "recente", label: "Mais Recentes" },
              { value: "antigo", label: "Mais Antigo" },
            ]}
            onChange={(target) => setOrderBy(target)}
            className="!mb-0 font-bold appearance-none outline-none h-full"
          />

          <ChevronDownButton className="w-[30px] h-[30px] absolute top-1/2 -translate-y-1/2 right-0 pointer-events-none" />
        </div>
      </div>

      <ModalSimulators isOpen={isModalOpenSimulators} onClose={closeModalSimulators} clienteId={idCliente} />
    </div>
  );
};

export default Filtro;
